module.exports = __webpack_public_path__ + "img/id.6e4005d1.png";